import { TipoPerfilUtil } from '@/core/types/tipo-perfil'

export const EmpresaUtils = {

  isEmpresaEscolhida: () => {
    return !!localStorage.getItem('empresa')
  },

  setEmpresa: empresa => {
    localStorage.setItem('empresa', JSON.stringify(empresa))
  },

  resetEmpresa: () => {
    localStorage.removeItem('empresa')
  },

  getEmpresa: () => JSON.parse(localStorage.getItem('empresa')),

  getEmpresasB2B: usuario => {
    const empresas = []
    usuario.empresas.forEach(function (empresa) {
      if (empresa.b2b === 1) {
        empresas.push(empresa)
      }
    })
    return empresas
  },

  limitaEmpresas: usuario => {
    /*
      Método para limitar as empresas que o usuário pode escolher para alimentar conteúdo.
      Se for AdmiJaleko, pode escolher qualquer empresa que esteja associado (empresa_users).
      Se não for AdminJaleko, só pode escolher entre as empresas b2b que ele esteja associado(empresa_users).
      Regra provisória.
    */
    if (TipoPerfilUtil.isAdminJaleko(usuario.perfil_id) || TipoPerfilUtil.isEditor(usuario.perfil_id)) {
      return usuario.empresas
    }
    return EmpresaUtils.getEmpresasB2B(usuario)
  }

}

export default EmpresaUtils
